export default __webpack_public_path__ + "static/media/MRBLES.6301f3b4.jpg";